import React from 'react'
import cardOne from './Images/rowOne/cardOne.jpg'
import cardTwo from './Images/rowOne/cardTwo.jpg'
import cardThree from './Images/rowOne/cardThree.jpg'
export default function Services() {
    return (
        <div className='py-5' style={{backgroundColor:'#6C6D71'}}>
        
            <h1 style={{ color: "white",fontWeight:'bold'}} className="text-center mb-5">OUR SERVICES</h1>
            
                  <div >
          
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-4">
                        <div style={{borderColor:"#6C6D71",borderRadius:'0px'}} class="card">
                            <img src={cardOne} class="card-img-top" alt="..." />
                            <div style={{backgroundColor:'#6C6D71',color:'white'}} class="card-body">
                                <h5 class="card-title">Best House Renovation</h5>
                                <p class="card-text">As the general contractor, we first create the highest level of trust and integrity with our clients...</p>
                                <a style={{color:'#A10302'}} href="#" >READ MORE</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div style={{borderColor:"#6C6D71",borderRadius:'0px'}} class="card">
                            <img src={cardTwo} class="card-img-top" alt="..." />
                            <div style={{backgroundColor:'#6C6D71',color:'white'}} class="card-body">
                                <h5 class="card-title">The Effective Teamwork</h5>
                                <p class="card-text">As the general contractor, we first create the highest level of trust and integrity with our clients...</p>
                                <a style={{color:'#A10302'}} href="#" >READ MORE</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div style={{borderColor:"#6C6D71",borderRadius:'0px'}} class="card">
                            <img src={cardThree} class="card-img-top" alt="..." />
                            <div style={{backgroundColor:'#6C6D71',color:'white'}} class="card-body">
                                <h5 class="card-title">The Green Building</h5>
                                <p class="card-text">Green construction refers to a structure and using process that is environmentally responsible...</p>
                                <a style={{color:'#A10302'}} href="#" >READ MORE</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/services.jsx